import { useState } from "react";
import { Link } from "react-router-dom";
import { reviewSeat, seatLayoutFor, type LocalReview } from "@anjabom/core";
import { InteractiveSeatMap } from "../components/InteractiveSeatMap";
import { SeatMemoryList } from "../components/SeatMemoryList";
import { useLocalState } from "../state/LocalStateProvider";
export function SeatMapPage() {
	const { state } = useLocalState();
	const seats = state.reviews.flatMap((r) => {
		const seat = reviewSeat(r, state);
		return seat ? [{ seat, review: r }] : [];
	});
	const groups = [
		...new Map(
			seats.map(({ seat }) => [`${seat.venueId}:${seat.spaceId}`, seat]),
		).values(),
	];
	const [selected, setSelected] = useState(""),
		[memories, setMemories] = useState<LocalReview[]>([]);
	const current =
		groups.find((s) => `${s.venueId}:${s.spaceId}` === selected) ?? groups[0];
	const layout = current
		? seatLayoutFor(current.venueId, current.spaceId)
		: null;
	return (
		<section className="page narrow stack-lg">
			<h1>내 좌석 지도</h1>
			{!groups.length ? (
				<>
					<p>관람 기억을 남기면 여기에 점이 찍혀요.</p>
					<Link to="/start?intent=record">기억 남기기</Link>
				</>
			) : (
				<>
					<label className="field">
						장소와 홀
						<select
							className="input"
							value={current ? `${current.venueId}:${current.spaceId}` : ""}
							onChange={(e) => {
								setSelected(e.target.value);
								setMemories([]);
							}}
						>
							{groups.map((s) => (
								<option
									key={`${s.venueId}:${s.spaceId}`}
									value={`${s.venueId}:${s.spaceId}`}
								>
									{s.venueName} · {s.spaceName}
								</option>
							))}
						</select>
					</label>
					{layout && layout.precision !== "booking" ? (
						<InteractiveSeatMap
							key={layout.layoutVersionId}
							layout={layout}
							selection={null}
							onSelectSection={() => undefined}
							onSelectSeat={(s) =>
								setMemories(
									seats
										.filter(
											(m) =>
												m.seat.venueId === current?.venueId &&
												m.seat.spaceId === current?.spaceId &&
												m.seat.sectionCode === s.sectionCode &&
												m.seat.rowLabel === s.rowLabel &&
												m.seat.seatNumber === s.seatNumber,
										)
										.map((m) => m.review),
								)
							}
							memories={seats
								.filter(
									(m) =>
										m.seat.venueId === current?.venueId &&
										m.seat.spaceId === current?.spaceId,
								)
								.map((m) => ({ ...m.seat, score: m.review.scores.시야 }))}
						/>
					) : (
						<p>이 홀은 좌석도 대신 목록으로 기억을 보여 드려요.</p>
					)}
					<SeatMemoryList
						reviews={
							memories.length
								? memories
								: seats
										.filter(
											(m) =>
												m.seat.venueId === current?.venueId &&
												m.seat.spaceId === current?.spaceId,
										)
										.map((m) => m.review)
						}
						state={state}
					/>
				</>
			)}
		</section>
	);
}
